export { default } from './ObservedBadge';
